import React, { useEffect } from 'react';
import { Map, Marker, useMap } from '@vis.gl/react-google-maps';

function MapController({ selectedLocation }) {
  const map = useMap();

  useEffect(() => {
    if( map && selectedLocation ) {
      map.panTo({
        lat: selectedLocation.latitude,
        lng: selectedLocation.longitude,
      });
      map.setZoom(15);
    }
  }, [map, selectedLocation]);

  return null;
}

export default function MapComponent({ style, selectedLocation, onSelectLocation }) {
  return (
    <Map
      style={style}
      defaultCenter={{ lat: -6.1754, lng: 106.8272 }}
      defaultZoom={15}
      disableDefaultUI={true}
      onClick={(e) => {
        if (e.detail.latLng) {
          onSelectLocation({
            latitude: e.detail.latLng.lat,
            longitude: e.detail.latLng.lng,
          });
        }
      }}
      // mapTypeControl={false}      {/* Removes top-left Map/Satellite/Terrain box */}
      // streetViewControl={false}   {/* Removes yellow Pegman icon */}
      // fullscreenControl={false}   {/* Removes top-right fullscreen button */}
      // zoomControl={true}          {/* Keeps only +/- zoom buttons */}
    >
      <MapController selectedLocation={selectedLocation} />

      {selectedLocation && (
        <Marker position={{ 
          lat: selectedLocation.latitude, 
          lng: selectedLocation.longitude 
        }} />
      )}
    </Map>
  );
}